import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../../components/auth/useAuth'
import { addAnalisysType, getAnalisysTypes,getAnalisysType, editAnalisysType, removeAnalisysType } from '../../../actions/analisysTypesActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../../components/loaders/Loader'
import AnalisysTypeForm from '../../../components/forms/AnalisysTypeForm'
import { getParameters } from '../../../actions/parametersActions'


export default function AnalisysTypes() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const {analisysTypes, analisysType, resultAnalisysType, loading} = useSelector(state=>state.analisysTypes)
    const {parameters} = useSelector(state=>state.parameters)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

    useEffect(() => {
        if(clientauth){
            dispatch(getAnalisysTypes())
            dispatch(getParameters())
        }
    },[dispatch, t, clientauth])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({
            name: '',
            params: []
        })
        setModalShow(true)
    }

    const selectAnalisysType = (analisysType) => {
        dispatch(getAnalisysType(analisysType._id))
        setIsAddingOrEditing('editing')
        setFormState(analisysType)
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleSelectChange = (element)=>{
        setFormState({
            ...formState,
            [element.target.name]: element.target.value
        })
    }

    const handleParamsChange = (updatedParams) => {
        setFormState({
            ...formState,
            params: updatedParams
        })
    }

    useEffect(()=>{
        if (analisysType) {
            setFormState(analisysType)
        }
    }, [analisysType, dispatch])

    const handleSubmit = async(e) => {
        e.preventDefault()
        setIsRegistering(true)

        const newFormState = {
            ...formState,
            params: formState.params || []
        }

        if(isAddingOrEditing==='editing'){
            dispatch(editAnalisysType(newFormState, newFormState._id));
        }else{
            dispatch(addAnalisysType(newFormState));
        }
        setIsRegistering(false)
    }

    const handleDeleteAnalisysTypes = async(e, analisysTypeId) => {
        e.preventDefault()
        Swal.fire({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('global.accept'),
            cancelButtonText: t('global.cancel'),
            icon: 'warning',
            html: t('admin.analisysTypes.areyousureremove')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeAnalisysType(analisysTypeId))
                setModalShow(false)
            }
        })
    }

    useEffect(() => {
        if(resultAnalisysType){
            let resultAnalisysTypeTemp = resultAnalisysType
            dispatch({ type: 'ANALISYSTYPE_RESET_RESULT'})
            switch (resultAnalisysTypeTemp) {
                case 'addsuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.analisysTypes.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break
                case 'editsuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.analisysTypes.editsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break
                default:
                    break
            }
        }
    // eslint-disable-next-line
    }, [resultAnalisysType])

    const columnsAnalisysTypes = [
        {
            name: t('admin.analisysTypes.name'),
            cell: analisysType =>
                <div className='cursor' onClick={() => selectAnalisysType(analisysType)}>
                    {analisysType.name}
                </div>,
            selector: (analisysType) => `${analisysType.name}`,
            sortable: true,
        },{
            name: t('admin.analisysTypes.parameters'),
            width: '60%',
            left: true,
            cell: analisysType =>
                <div className='my-2'>
                    <div className='cursor py-2 text-start'
                        style={{
                            maxHeight: '200px',   // altura máxima visible
                            overflowY: 'auto',    // scroll si hay más contenido
                            overflowX: 'hidden'   // evita scroll horizontal
                        }} onClick={() => selectAnalisysType(analisysType)}>
                        {analisysType.params && analisysType.params.sort((a, b) => a.parameter.name.localeCompare(b.parameter.name)).map(param => (
                            <div key={param._id}>
                                {`${param.parameter.name} | Min: ${param.minValue} ${t(`measures.${param.unitMeasure}`)} - Max: ${param.maxValue} ${t(`measures.${param.unitMeasure}`)}`}
                            </div>
                        ))}
                    </div>
                </div>,
            selector: (analisysType) => `${analisysType.name}`,
            sortable: true,
        },{
            name: '',
            width: '80px',
            cell: analisysType =>
                <div className='cursor' onClick={() => selectAnalisysType(analisysType)}>
                    <i className='fas fa-pencil'></i>
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='mt-5 px-0'>
            <Row>
                <Col className='text-center'>
                    <h1>{t('admin.analisysTypes.analisysTypes')}</h1>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        {t('admin.analisysTypes.createanalisysType')}
                    </Button>
                </Col>
            </Row>

            {
                loading
                    ?
                        <Loader/>
                    :
                        <Row>
                            <Col xs={12}>
                            {analisysTypes?.length > 0
                                ?
                                    <CustomDataTable
                                        columns={columnsAnalisysTypes}
                                        data={[...analisysTypes].sort((a, b) => a.name.localeCompare(b.name))}
                                        exportable={true}
                                        printable={false}
                                        filter={true}
                                    />
                                :
                                    <h4 className='mt-4 text-center'>{t('admin.analisysTypes.thereisnotanalisysTypes')}</h4>
                            }
                            </Col>
                        </Row>

            }
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.analisysTypes.analisysTypes')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    { parameters?.length >0
                    ?
                    <AnalisysTypeForm
                        state={formState}
                        parameters={[...parameters]?.sort((a, b) => a.name.localeCompare(b.name))}
                        handleInputChange={handleInputChange}
                        handleSelectChange={handleSelectChange}
                        handleParamsChange={handleParamsChange}
                        handleDeleteAnalisysTypes={handleDeleteAnalisysTypes}
                        submit={handleSubmit}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                    />
                    :
                    <> </>
                    }
                </Modal.Body>
            </Modal>
        </Container>
    )
}